/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: 'titulo-dashboard',
    title: 'Bookkeeping',
    subtitle: 'Gestiona tus utilidades y gastos',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'userdashboard',
    title: 'Dashboard',
    type: 'basic',
    icon: 'heroicons_outline:home',
    link: 'user/dashboard',
  },
  {
    id: 'userworkers',
    title: 'Trabajadores (1099)',
    type: 'basic',
    icon: 'heroicons_outline:user-group',
    link: 'user/workers',
  },
  {
    id: 'userproviders',
    title: 'Proveedores',
    type: 'basic',
    icon: 'heroicons_outline:archive-box-arrow-down',
    link: 'user/providers',
  },
  {
    id: 'uservehicles',
    title: 'Vehiculos',
    type: 'basic',
    icon: 'heroicons_outline:truck',
    link: 'user/vehicles',
  },
  {
    id: 'userbankaccounts',
    title: 'Cuentas Bancarias',
    type: 'basic',
    icon: 'heroicons_outline:building-library',
    link: 'user/bankaccounts',
    badge: {
      title: 'Nuevo',
      classes: 'px-2.5 bg-[#c2000d] text-white rounded-full',
    },
  },
  {
    id: 'userloans',
    title: 'Préstamos y Financiamientos',
    type: 'basic',
    icon: 'heroicons_outline:banknotes',
    link: 'user/loans',
    badge: {
      title: 'Nuevo',
      classes: 'px-2.5 bg-[#c2000d] text-white rounded-full',
    },
  },
  {
    id: 'usercategories',
    title: 'Cuentas',
    type: 'basic',
    icon: 'heroicons_outline:list-bullet',
    link: 'user/categories',
  },
  {
    id: 'usersubcategories',
    title: 'SubCuentas',
    type: 'basic',
    icon: 'heroicons_outline:queue-list',
    link: 'user/subcategories',
  },
  {
    id: 'titulo-importacion-datos',
    title: 'Importación de datos',
    subtitle: 'Importa datos desde archivos',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'importacion-datos',
    title: 'Importación de datos',
    type: 'basic',
    icon: 'heroicons_outline:arrow-down-tray',
    link: 'user/dataimport',
  },
  {
    id: 'titulo-reportes',
    title: 'Reportes',
    subtitle: 'Genera y visualiza reportes financieros',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'reportes',
    title: 'Reportes',
    type: 'basic',
    icon: 'heroicons_outline:document-magnifying-glass',
    link: 'user/detailed-reports',
  },
  {
    id: 'titulo-facturas',
    title: 'Facturas',
    subtitle: 'Crea tus clientes, productos y facturas',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'facturas',
    title: 'Facturas',
    icon: 'heroicons_outline:clipboard-document-list',
    type: 'collapsable',
    badge: {
      title: 'Nuevo',
      classes: 'px-2.5 bg-[#c2000d] text-white rounded-full',
    },
    children: [
      {
        id: 'userclients',
        title: 'Clientes',
        type: 'basic',
        icon: 'heroicons_outline:user-circle',
        link: 'user/clients',
      },
      {
        id: 'userproducts',
        title: 'Productos',
        type: 'basic',
        icon: 'heroicons_outline:shopping-bag',
        link: 'user/products',
      },
      {
        id: 'userbills',
        title: 'Facturas',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: 'user/bills',
      },
    ],
  },
  {
    id: 'titulo-cursos',
    title: 'Cursos',
    subtitle: 'Aprende de la mejor forma sobre tus finanzas',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'academy',
    title: 'Cursos',
    type: 'basic',
    icon: 'heroicons_outline:academic-cap',
    link: 'user/cursos',
    badge: {
      title: 'Nuevo',
      classes: 'px-2.5 bg-[#c2000d] text-white rounded-full',
    },
  },
  {
    id: 'titulo-help-center',
    title: 'Soporte',
    subtitle: 'Preguntas frecuentes y soporte',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'help-center',
    title: 'Centro de ayuda',
    type: 'basic',
    icon: 'heroicons_outline:chat-bubble-left-right',
    link: 'user/help-center',
  },
];

export const adminNavigation: FuseNavigationItem[] = [
  {
    id: 'titulo-admin-dashboard',
    title: 'Administrador',
    subtitle: 'Crea usuarios cuentas y subcuentas',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'dashboard',
    title: 'Dashboard',
    type: 'basic',
    icon: 'heroicons_outline:home',
    link: '/dashboard',
  },
  {
    id: 'users',
    title: 'Usuarios',
    type: 'basic',
    icon: 'heroicons_outline:users',
    link: '/users',
  },
  {
    id: 'categories',
    title: 'Cuentas',
    type: 'basic',
    icon: 'heroicons_outline:list-bullet',
    link: '/categories',
  },
  {
    id: 'subcategories',
    title: 'SubCuentas',
    type: 'basic',
    icon: 'heroicons_outline:queue-list',
    link: '/subcategories',
  },
  {
    id: 'titulo-admin-cursos',
    title: 'Cursos',
    subtitle: 'Crea los cursos y clases para los usuarios',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'cursos',
    title: 'Cursos',
    type: 'basic',
    icon: 'heroicons_outline:queue-list',
    link: '/cursos',
    badge: {
      title: 'Nuevo',
      classes: 'px-2.5 bg-[#c2000d] text-white rounded-full',
    },
  },
  {
    id: 'titulo-usuario-dashboard',
    title: 'Bookkeeping usuario',
    subtitle: 'Vistas de bookkeeping del usuario',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'userdashboard',
    title: 'Dashboard de usuario',
    type: 'basic',
    icon: 'heroicons_outline:home',
    link: 'user/dashboard',
  },
  {
    id: 'userworkers',
    title: 'Trabajadores (1099)',
    type: 'basic',
    icon: 'heroicons_outline:user-group',
    link: 'user/workers',
  },
  {
    id: 'userproviders',
    title: 'Proveedores',
    type: 'basic',
    icon: 'heroicons_outline:archive-box-arrow-down',
    link: 'user/providers',
  },
  {
    id: 'uservehicles',
    title: 'Vehiculos',
    type: 'basic',
    icon: 'heroicons_outline:truck',
    link: 'user/vehicles',
  },
  {
    id: 'userbankaccounts',
    title: 'Cuentas Bancarias',
    type: 'basic',
    icon: 'heroicons_outline:building-library',
    link: 'user/bankaccounts',
    badge: {
      title: 'Nuevo',
      classes: 'px-2.5 bg-[#c2000d] text-white rounded-full',
    },
  },
  {
    id: 'userloans',
    title: 'Préstamos y Financiamientos',
    type: 'basic',
    icon: 'heroicons_outline:banknotes',
    link: 'user/loans',
    badge: {
      title: 'Nuevo',
      classes: 'px-2.5 bg-[#c2000d] text-white rounded-full',
    },
  },
  {
    id: 'titulo-usuario-facturas',
    title: 'Facturas usuario',
    subtitle: 'Vistas del usuario de facturas, productos y clientes',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'facturas',
    title: 'Facturas',
    icon: 'heroicons_outline:clipboard-document-list',
    type: 'collapsable',
    badge: {
      title: 'Nuevo',
      classes: 'px-2.5 bg-[#c2000d] text-white rounded-full',
    },
    children: [
      {
        id: 'userclients',
        title: 'Clientes',
        type: 'basic',
        icon: 'heroicons_outline:user-circle',
        link: 'user/clients',
      },
      {
        id: 'userproducts',
        title: 'Productos',
        type: 'basic',
        icon: 'heroicons_outline:shopping-bag',
        link: 'user/products',
      },
      {
        id: 'userbills',
        title: 'Facturas',
        type: 'basic',
        icon: 'heroicons_outline:document-text',
        link: 'user/bills',
      },
    ],
  },
  {
    id: 'titulo-usuario-importacion-datos',
    title: 'Importación de datos usuario',
    subtitle: 'Vistas del usuario para importar datos',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'user-dataimport',
    title: 'Importación de datos',
    type: 'basic',
    icon: 'heroicons_outline:arrow-down-tray',
    link: 'user/dataimport',
  },
  {
    id: 'titulo-usuario-reportes',
    title: 'Reportes usuario',
    subtitle: 'Reportes financieros del usuario',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'user-reportes',
    title: 'Reportes',
    type: 'basic',
    icon: 'heroicons_outline:document-magnifying-glass',
    link: 'user/detailed-reports',
  },
  // ----------------- User Listas de anos y meses -----------------
  // {
  //   id: "usertaxyears",
  //   title: "Usuario Años de impuestos",
  //   type: "basic",
  //   icon: "heroicons_outline:chart-pie",
  //   link: "user/taxyears",
  // },
  // {
  //   id: "usertaxmonths",
  //   title: "Usuarios Meses de impuestos",
  //   type: "basic",
  //   icon: "heroicons_outline:chart-pie",
  //   link: "user/taxmonths",
  // },
  // ------------------------------------------
  // {
  //   id: "usermonthdashboard",
  //   title: "Usuarios dashboard de mes",
  //   type: "basic",
  //   icon: "heroicons_outline:chart-pie",
  //   link: "user/monthdashboard",
  // },
  // {
  //   id: "userdailyincome",
  //   title: "Usuario Ingresos diarios",
  //   type: "basic",
  //   icon: "heroicons_outline:chart-pie",
  //   link: "user/dailyincome",
  // },
  // {
  //   id: "userpurchasedproducts",
  //   title: "Usuario Compras de productos",
  //   type: "basic",
  //   icon: "heroicons_outline:chart-pie",
  //   link: "user/purchasedproducts",
  // },
  // {
  //   id: "userworkerspayment",
  //   title: "Usuario Pago de trabajadores (1099)",
  //   type: "basic",
  //   icon: "heroicons_outline:chart-pie",
  //   link: "user/workerspayment",
  // },
  // {
  //   id: "userprofitsandlossesmonth",
  //   title: "Usuario Ganancias y pérdidas del mes",
  //   type: "basic",
  //   icon: "heroicons_outline:chart-pie",
  //   link: "user/profitsandlossesmonth",
  // },
  // {
  //   id: "useroperationalexpenses",
  //   title: "Usuario Gastos operacionales",
  //   type: "basic",
  //   icon: "heroicons_outline:chart-pie",
  //   link: "user/operationalexpenses",
  // },
  // {
  //   id: "usermonthlymileage",
  //   title: "Usuario Millaje mensual",
  //   type: "basic",
  //   icon: "heroicons_outline:chart-pie",
  //   link: "user/monthlymileage",
  // },
  // {
  //   id: "userannualtotal",
  //   title: "Usuario Total anual",
  //   type: "basic",
  //   icon: "heroicons_outline:chart-pie",
  //   link: "user/annualtotal",
  // },
  {
    id: 'titulo-usuario-cursos',
    title: 'Cursos',
    subtitle: 'Aprende de la mejor forma sobre tus finanzas',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'admin-academy',
    title: 'Cursos',
    type: 'basic',
    icon: 'heroicons_outline:academic-cap',
    link: 'user/cursos',
    badge: {
      title: 'Nuevo',
      classes: 'px-2.5 bg-[#c2000d] text-white rounded-full',
    },
  },
  {
    id: 'titulo-usuario-soporte',
    title: 'Soporte usuario',
    subtitle: 'Vistas del usuario de soporte',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'help-center',
    title: 'Centro de ayuda',
    type: 'basic',
    icon: 'heroicons_outline:chat-bubble-left-right',
    link: 'user/help-center',
  },
  {
    id: 'titulo-usuario-compras',
    title: 'Compras usuario',
    subtitle: 'Vistas del usuario de compras',
    type: 'group',
    icon: 'heroicons_outline:bars-3',
    classes: {
      title: 'text-[#ffffff] font-bold',
    },
  },
  {
    id: 'pricing',
    title: 'Precios',
    type: 'basic',
    icon: 'heroicons_outline:shopping-cart',
    link: 'user/pricing',
  },
  {
    id: 'purchaseconfirmation',
    title: 'Confirmacion de compra',
    type: 'basic',
    icon: 'heroicons_outline:check-badge',
    link: 'user/purchaseconfirmation',
  },
  {
    id: 'purchaseerror',
    title: 'Error de compra',
    type: 'basic',
    icon: 'heroicons_outline:exclamation-triangle',
    link: 'user/purchaseerror',
  },
];

export const compactNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];
export const futuristicNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];
export const horizontalNavigation: FuseNavigationItem[] = [
  {
    id: 'example',
    title: 'Example',
    type: 'basic',
    icon: 'heroicons_outline:chart-pie',
    link: '/example',
  },
];
